import { render, staticRenderFns } from "./account-menu.vue?vue&type=template&id=7510e9b3"
import script from "./account-menu.vue?vue&type=script&lang=js"
export * from "./account-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports